import {isEmail} from "./Utils";

// validation for dashboard componants
 export function validateResetPassword(values) {
   let errors = {};
   if (!values.password) {
     errors.password = 'Password is required';
  } else {
    const hasMinLength = String(values.password).length >= 8;
    const hasUpper = /[A-Z]/.test(values.password);
    const hasLower = /[a-z]/.test(values.password);
    const hasNumber = /\d/.test(values.password);
    const hasSymbol = /[@#$%&!\?]/.test(values.password);
    if (!(hasMinLength && hasUpper && hasLower && hasNumber && hasSymbol)) {
      errors.password = 'Password must be 8+ characters with an upper case, lower case, number, and symbol (@, #, $, %, &, !, ?)';
    }
   }
   if (!values.confirmPassword) {
     errors.confirmPassword = 'Confirm Password is required';
   } else if (values.password !== values.confirmPassword) {
     errors.confirmPassword = 'Password Should match';
   }
 
   return errors;
 
 }

 export function validateFormUser(values, formType, isAdvanceOption = false, selectedRoleId = null,isTempUserEnable = false,selectedDate) {
  let errors = {};

  if (!values.lastName) {
    errors.lastName = "Name is required";
  }

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!isEmail(values.email)) {
    errors.email = "Invalid email format";
  }

  if (!values.mobile) {
    errors.mobile = "Mobile number is required";
  }

  if (formType === "edit") {
    if (!values.status) {
      errors.status = "Status is required.";
    }

    if (selectedRoleId != null && selectedRoleId >= 10 && !values.userreference) {
      errors.userreference = "User Reference is required for this role.";
    }
  } else {
    if (!values.userRoleId) {
      errors.userRoleId = "User Role is required";
    }

    if (isAdvanceOption) {
      if (!values.username) {
        errors.username = "Username is required";
      }
    if (!values.password) {
      errors.password = "Password is required";
    } else {
      const requirements = [
        { regex: /.{8,}/, label: "8+ characters" },
        { regex: /[A-Z]/, label: "uppercase" },
        { regex: /[a-z]/, label: "lowercase" },
        { regex: /\d/, label: "number" },
        { regex: /[@$!%?&#]/, label: "symbol (@$!%?&#)" }
      ];

      const missing = requirements
        .filter(req => !req.regex.test(values.password))
        .map(req => req.label);

      if (missing.length > 0) {
        errors.password = `Password must contain: ${missing.join(", ")}`;
      }
    }

    if (!values.confirmPassword) {
      errors.confirmPassword = "Confirm Password is required";
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = "Passwords must match";
      }
    }

    if (selectedRoleId != null && selectedRoleId >= 10 && !values.userreference) {
      errors.userreference = "User Reference is required for this role.";
    }

    if(isTempUserEnable == true && selectedDate == null){
      errors.tempUser = "Expiry Date is Required"
    }

  }

  return errors;
}

  export const validateAddDrop = (values, referencesList) => {
      const errors = {};
      
      if (values.references && values.references.length > 0) {
        const selectedReferenceIds = values.references;
        const currentReferenceIds = referencesList.map((ref) => ref.id);
    
        const isSame = selectedReferenceIds.every(id => currentReferenceIds.includes(id)) && selectedReferenceIds.length === currentReferenceIds.length;
    
        if (isSame) {
          errors.references = "You didn't change the selection.";
        }
      } 
      return errors;
    };

//validation for accountPage component
export const validateAccountForm = (values) => {
  const errors = {};
  
  if (!values.name) { errors.name = "Name is required."; }
  if (!values.contactName) { errors.contactName = "Contact Name is required."; }
  if (!values.contactEmail) {  errors.contactEmail = "Contact Email is required."; } 
  else if (!isEmail(values.contactEmail)) { errors.contactEmail = "Invalid email format."; }
  if (!values.contactPhoneNumber) { errors.contactPhoneNumber = "Contact Phone Number is required."; } 
  else if (!/^\+?\d{10,15}$/.test(values.contactPhoneNumber)) {  errors.contactPhoneNumber = "Invalid phone number format. Use 10-15 digits."; }

  return errors;
};
  
//validation for corporatePage component
export const validateFormCorporate = (values) => {
  const errors = {};
  
  if (!values.accountId) { errors.accountId = "Account ID is required.";}
  if (!values.name) { errors.name = "Name is required."; }
  if (!values.contactName) { errors.contactName = "Contact Name is required."; }
  if (!values.contactEmail) {  errors.contactEmail = "Contact Email is required."; }
  else if (!isEmail(values.contactEmail)) { errors.contactEmail = "Invalid email format."; }
  if (!values.contactPhoneNumber) { errors.contactPhoneNumber = "Contact Phone Number is required."; }
  else if (!/^\+?\d{10,15}$/.test(values.contactPhoneNumber)) {  errors.contactPhoneNumber = "Invalid phone number format. Use 10-15 digits."; }

  return errors;
};

//validation for change configuration
export const validateChangeConfiguration = (values) => {
  const errors = {};

  if (!values.hosturl) {
    errors.hosturl = "Host URL is required.";
  }
  if (!values.androidversion) {
    errors.androidversion = "Android version is required.";
  }
  if (!values.iosversion) {
    errors.iosversion = "IOS version is required.";
  }

  return errors;
};

// Enhanced validation for Privilege Popup with hierarchy support
export const validatePrivilegeForm = (values, existingPrivileges = [], type = 'add-high', defaultId = null, parentId = null) => {
    const errors = {};

    if (!values.name || values.name.trim() === '') {
        errors.name = 'Name is required';
    } else {
        const trimmedName = values.name.trim().toLowerCase();
        if (type === 'add-high') {
        const isDuplicate = existingPrivileges.some(privilege =>
            privilege.parentId === 'high-privilege' &&
            privilege.name.toLowerCase() === trimmedName &&
                (type === 'add-high' || privilege.id !== defaultId)
            );
            if (isDuplicate) {
                errors.name = 'High Privilege name already exists';
            }
        } else if (type === 'add-new') {
            const parentPrivilege = existingPrivileges.find(p => p.id === parentId);
            if (parentPrivilege && parentPrivilege.child) {
                const isDuplicate = parentPrivilege.child.some(child =>
                    child.name.toLowerCase() === trimmedName
                );
                if (isDuplicate) {
                    errors.name = 'Sub-privilege name already exists under this parent';
                }
            }
        } else if (type === 'update') {
            const currentPrivilege = existingPrivileges.find(p => p.id === defaultId);
            if (currentPrivilege) {
                if (currentPrivilege.parentId === 'high-privilege') {
                    const isDuplicate = existingPrivileges.some(privilege =>
                        privilege.parentId === 'high-privilege' &&
                        privilege.name.toLowerCase() === trimmedName &&
                        privilege.id !== defaultId
                    );
                    if (isDuplicate) {
            errors.name = 'High Privilege name already exists';
                    }
                } else {
                    const parentPrivilege = existingPrivileges.find(p => p.id === currentPrivilege.parentId);
                    if (parentPrivilege && parentPrivilege.child) {
                        const isDuplicate = parentPrivilege.child.some(child =>
                            child.name.toLowerCase() === trimmedName &&
                            child.id !== defaultId
                        );
                        if (isDuplicate) {
                            errors.name = 'Sub-privilege name already exists under this parent';
                        }
                    }
                }
            }
        }
    }

    if (!values.actions || values.actions.length === 0) {
        errors.actions = 'Please add at least one action';
    }

// validation for add new action input
    if (values.hasOwnProperty('newActionInput')) {
        const text = (values.newActionInput || '').toString();
        if (text.trim() === '') {
            errors.newActionInput = 'Action name is required';
        }
    }

    return errors;
};

// validation for add new role / update role
export function validateRoleForm(values, { allRoles = [], formType = "new", selectedRole = null, privilegesCount = 0} = {}) {
    const errors = {};

    if (formType === "new") {
        if (!values.id && values.id !== 0) {
            errors.id = "ID is required";
        } else if (!/^\d+$/.test(String(values.id).trim())) {
            errors.id = "ID should contain only numbers";
        } else {
            const idNum = parseInt(values.id, 10);
            const idExists = allRoles.some(r => r.id === idNum);
            if (idExists) errors.id = "ID already exists";
        }
    } else {
        if (values.id && !/^\d+$/.test(String(values.id).trim())) {
            errors.id = "ID should contain only numbers";
        }
    }

    if (!values.name || values.name.trim() === "") {
        errors.name = "Name is required";
    } else {
        const lower = values.name.trim().toLowerCase();
        const clash = allRoles.some(r =>
            r.name.toLowerCase() === lower &&
            (formType !== "edit" || r.id !== selectedRole?.id)
        );
        if (clash) errors.name = "Name already exists";
    }

    if (!privilegesCount || privilegesCount === 0) {
        errors.privileges = "At least one privilege must be selected";
    }

    return errors;
}

export function validateReferenceCodeModal(values) {
    const errors = {};
    if (!values) {
        errors.roleId = "Role is required";
        errors.referenceId = "Reference is required";
        return errors;
    }

    const roleVal = values.roleId ?? values.role ?? values.selectedRoleId;
    const refVal = values.referenceId ?? values.reference ?? values.selectedReferenceId;

    if (!roleVal) {
        errors.roleId = "Role is required";
    }
    if (!refVal) {
        errors.referenceId = "Reference is required";
    }

    return errors;
}


